<div class="container-fluid">
  <div class="row" id="supervisorProgramsButtons">
    <div class="col">
      <button
        (click)="addProgramButtonClicked()"
        id="addProgramButton"
        class="side-menu-button2 w-100"
      >
        + Program
      </button>
    </div>
    <div class="col">
      <button
        (click)="getFromBSPButtonClicked()"
        id="getFromBSPButton"
        class="side-menu-button2 w-100"
      >
        Get From BSP
      </button>
    </div>
  </div>

  <p-table
    id="programs"
    [value]="filteredPrograms()"
    #dt
    dataKey="ID"
    [tableStyle]="{ width: '100%' }"
    [loading]="isLoading"
    [rows]="25"
    [totalRecords]="getTotalProgramsCount()"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [responsive]="true"
    [resizableColumns]="true"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    [scrollHeight]="'flex'"
    [rowTrackBy]="trackByProgramId"
    >
    <ng-template pTemplate="caption">
      <div class="container text-center">
        <!-- Search Row -->
        <div class="row mb-3">
          <div class="col-12">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                placeholder="Program Name"
                id="searchBarInput"
                class="w-100"
                (ngModelChange)="exitEditModeIfActive()"
                [(ngModel)]="searchKeyword"
                (ngModelChange)="exitEditModeIfActive()"
              />
            </span>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                placeholder="Target Name"
                id="searchTargetBarInput"
                class="w-100"
                (ngModelChange)="exitEditModeIfActive()"
                [(ngModel)]="searchTargetKeyword"
                (ngModelChange)="exitEditModeIfActive()"
              />
            </span>
          </div>
        </div>

        <!-- Collapsible Filters Row -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex align-items-center">
              <button
                id="filtersButton"
                type="button"
                class="btn btn-link p-0 me-2"
                (click)="toggleFiltersCollapsed()"
                [attr.aria-expanded]="!filtersCollapsed()"
                aria-controls="filtersCollapse"
                style="font-size: 1.2rem; font-weight: bold; color: #719eb6; text-decoration: none;"
              >
                <i class="pi" [class.pi-chevron-right]="filtersCollapsed()" [class.pi-chevron-down]="!filtersCollapsed()"></i>
                Filters
              </button>
            </div>
            
            <div class="collapse" [class.show]="!filtersCollapsed()" id="filtersCollapse">

              <div class="row mt-3">
                <div class="d-flex flex-wrap gap-3">
                  <div>
                    <label for="selectedSkillAreas" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Skill Areas: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="this.supervisorHelperService.skillAreas()"
                                  name="selectedSkillAreas"
                                  [(ngModel)]="selectedSkillAreas"
                                  display="chip"
                                  [showClear]="true"
                                  optionLabel="SkillAreaName"
                                  placeholder="Skill Areas">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedPlaylists" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Playlists: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="this.supervisorHelperService.playlists()"
                                  name="selectedPlaylists"
                                  [(ngModel)]="selectedPlaylists"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Playlists"
                                  optionLabel="PlaylistName">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedTargets" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Targets: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="this.supervisorHelperService.targets()"
                                  name="selectedTargets"
                                  [(ngModel)]="selectedTargets"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Targets"
                                  optionLabel="TargetName">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedStatuses" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Statuses: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="possibleStatuses()"
                                  name="selectedStatuses"
                                  [(ngModel)]="selectedStatuses"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Status"
                                  optionLabel="label"
                                  optionValue="value">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Opened Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="openedDateRangeList()"
                                name="openedDateRange"
                                [(ngModel)]="openedDateRange"
                                display="chip"
                                (ngModelChange)="changedOpenedDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomOpenedDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="openedStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="openedEndDate" />
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Probed Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="probedDateRangeList()"
                                name="probedDateRange"
                                [(ngModel)]="probedDateRange"
                                display="chip"
                                (ngModelChange)="changedProbedDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomProbedDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="probedStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="probedEndDate" />
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Mastered Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="masteredDateRangeList()"
                                name="masteredDateRange"
                                [(ngModel)]="masteredDateRange"
                                display="chip"
                                (ngModelChange)="changedMasteredDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomMasteredDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="masteredStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="masteredEndDate" />
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Closed Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="closedDateRangeList()"
                                name="closedDateRange"
                                [(ngModel)]="closedDateRange"
                                display="chip"
                                (ngModelChange)="changedClosedDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomClosedDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="closedStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="closedEndDate" />
                  </div>
                </div>
                <div class="row mb-3 mt-3">
                  <div class="col-12">
                    <div class="d-flex flex-wrap gap-3 justify-content-end">
                      <!-- Out of Playlists Button -->
                      @if(!filterByOutOfPlaylists()) {
                        <p-button
                        [style]="{
                          color: '#719eb6',
                          backgroundColor: 'white',
                          border: '2px solid #719eb6',
                          'border-radius': '10px'
                        }"
                        label="Only Out of Playlists"
                        icon="pi pi-list"
                        (onClick)="toggleFilterByOutOfPlaylists()"
                      />
                      } @else {
                        <p-button
                        [style]="{
                          color: 'white',
                          backgroundColor: '#719eb6',
                          border: '2px solid white',
                          'border-radius': '10px'
                        }"
                        label="In/Out of Playlists (Default)"
                        icon="pi pi-list"
                        (onClick)="toggleFilterByOutOfPlaylists()"
                      />
                      }
                      @if(!includeDeleted()) {
                      <p-button
                      id="includeDeletedButton"
                        [style]="{
                          color: 'red',
                          backgroundColor: 'white',
                          border: '2px solid red',
                          'border-radius': '10px'
                        }"
                        label="Include Deleted"
                        icon="pi pi-trash"
                        (onClick)="toggleIncludeDeleted()"
                      />
                      } @else {
                      <p-button
                      id="excludeDeletedButton"
                        [style]="{
                          color: 'white',
                          backgroundColor: 'red',
                          border: '2px solid white',
                          'border-radius': '10px'
                        }"
                        label="Exclude Deleted"
                        icon="pi pi-trash"
                        (onClick)="toggleIncludeDeleted()"
                      />
                      } @if(!includeArchived()) {
                      <p-button
                      id="includeArchivedButton"
                        [style]="{
                          color: '#ffc107',
                          backgroundColor: 'white',
                          border: '2px solid #ffc107',
                          'border-radius': '10px',
                          'min-width': '170px'
                        }"
                        label="Include Archived"
                        icon="pi pi-folder"
                        (onClick)="toggleIncludeArchived()"
                      />
                      } @else {
                      <p-button
                      id="excludeArchivedButton"
                        [style]="{
                          color: 'white',
                          backgroundColor: '#ffc107',
                          border: '2px solid white',
                          'border-radius': '10px',
                          'min-width': '180px'
                        }"
                        label="Exclude Archived"
                        icon="pi pi-folder"
                        (onClick)="toggleIncludeArchived()"
                      />
                      }
                      <p-button
                      id="clearFiltersButton"
                        label="Clear"
                        [style]="{
                          'border-radius': '10px',
                          border: '2px solid #719eb6'
                        }"
                        icon="pi pi-filter-slash"
                        (click)="clearSearch()"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Order and Selection Row -->
        <div class="row mb-3">
          <div class="col-5">
            <div class="d-flex flex-wrap gap-3 align-items-center">
              <!-- Edit/Done button (only shown when custom order is selected) -->
              @if(orderMode() === 'custom') {
              <p-button
                [label]="isEditMode() ? 'Save' : 'Edit'"
                [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-pencil'"
                [style]="{
                  'border-radius': '10px',
                  border: '2px solid #28a745',
                  color: isEditMode() ? 'white' : '#28a745',
                  backgroundColor: isEditMode() ? '#28a745' : 'white'
                }"
                (onClick)="toggleEditMode()"
              />
              }
              
              <!-- Order dropdown -->
              <div class="d-flex align-items-center gap-2">
                <label style="font-size: 1rem; font-weight: bold; color: #719eb6; margin: 0;">Order:</label>
                <p-dropdown
                  id="orderDropdown"
                  [options]="orderOptions()"
                  [(ngModel)]="orderMode"
                  (ngModelChange)="onOrderModeChange()"
                  optionLabel="label"
                  optionValue="value"
                  [style]="{
                    'min-width': '150px',
                    'border-radius': '10px'
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex flex-wrap gap-3 justify-content-end">
              @if(!selectingForDeletion){
              <p-button
                label="Select Programs"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #719eb6'
                }"
                icon="pi pi-wrench"
                (click)="toggleIsSelecting()"
              />
              }
              @else {
              <p-button
                label="Select All"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-check-square"
                (click)="selectAllPrograms()"
              />
              <p-button
                [style]="{
                  color: 'red',
                  backgroundColor: 'white',
                  border: '2px solid red',
                  'border-radius': '10px'
                }"
                label="Delete Programs"
                icon="pi pi-trash"
                [disabled]="programIDsForDeletion.length === 0"
                (onClick)="deleteSelectedPrograms()"
              />
              <p-button
                label="Cancel"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-minus-circle"
                (click)="cancelIsSelecting()"
              />
              }
            </div>
          </div>
        </div>

      </div>
    </ng-template>

    <ng-template pTemplate="body" let-program>
      @if(orderMode() === 'custom' && isEditMode()) {
      <!-- Edit mode with overlay -->
      <tr class="edit-row">
        <td colspan="100%" class="p-0">
          <div class="edit-container" [id]="'edit-container-' + program.ID">
            <!-- Program content -->
            <div class="program-content">
              <app-program
                [patientID]="patientID()"
                [program]="program"
                [id]="program.ProgramName"
                [isExpanded]="isExpandedStatus[program.ID]"
                (isExpandedChange)="onProgramExpandedChange(program.ID, $event)"
                [includeDeleted]="includeDeleted()"
                [includeArchived]="includeArchived()"
                [isSelecting]="selectingForDeletion"
                [selectAll]="doSelectAll"
                (selectProgram)="selectProgram($event)"
              />
            </div>
            
            <!-- Semi-transparent overlay with arrows -->
            <div class="arrow-overlay" [class.moved]="hasPendingChanges(program.ID!)">
              <div class="arrow-row">
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveProgramToTop(program.ID!)"
                  [disabled]="isFirstProgram(program.ID!)"
                  title="Move to top">
                  <i class="pi pi-angle-double-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveProgramUp(program.ID!)"
                  [disabled]="isFirstProgram(program.ID!)"
                  title="Move up one">
                  <i class="pi pi-angle-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveProgramDown(program.ID!)"
                  [disabled]="isLastProgram(program.ID!)"
                  title="Move down one">
                  <i class="pi pi-angle-down"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveProgramToBottom(program.ID!)"
                  [disabled]="isLastProgram(program.ID!)"
                  title="Move to bottom">
                  <i class="pi pi-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
      } @else {
      <!-- Normal mode -->
      <app-program
        [patientID]="patientID()"
        [program]="program"
        [id]="program.ProgramName"
        [isExpanded]="isExpandedStatus[program.ID]"
        (isExpandedChange)="onProgramExpandedChange(program.ID, $event)"
        [includeDeleted]="includeDeleted()"
        [includeArchived]="includeArchived()"
        [isSelecting]="selectingForDeletion"
        [selectAll]="doSelectAll"
        (selectProgram)="selectProgram($event)"
        [statusesToFilter]="convertProgramStatusToTargetStatus(selectedStatuses())"
      />
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        There are no programs yet.
      </p>
    </ng-template>
  </p-table>
</div>
